import { Component } from '@angular/core';
import { LandingType01Component } from './landing-type01/landing-type01.component';
import { TFMService } from 'app/mock-api/tfm.service';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-client-landing',
  standalone: true,
  imports: [LandingType01Component],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent {

  public view: any = {

  };

  constructor(private _tfmService: TFMService, private title: Title, private metaService: Meta, private _router: Router) { }

  ngOnInit(): void {
    if (this._tfmService.view.isClient) {
      this._tfmService.getSite().then(res => {
        this.view.site = res;
        this._tfmService.log("Website", this.view.site);

        // this.title.setTitle(this.view.site.name + " - " + this.view.site.slogan);
        if (this.view.site) {

          //Set title
          this.title.setTitle(this.view.site.name + " - " + this.view.site.slogan);

          // Set description & keywords
          this.metaService.updateTag( { name:'description', content:this.view.site.slogan});
          this.metaService.updateTag( { name:'keywords', content:this.view.site.name});
        }
        // this.metaService.updateTag( { name:'description', content:'Simplifying Travel'});
        // this.metaService.updateTag( { name:'keywords', content:'Travel, Tourism, Flights'});

      });
    }
    else {
      this._router.navigate(["dashboard"]);
    }
  }
}
